import apiClient from '@/services/api'

export default {
  setCompletedAssociateSequence({ commit }, { sequence_type, payload }) {
    commit('SET_COMPLETED_ASSOCIATE_SEQUENCE', {
      payload: payload,
      type: sequence_type
    })
  },

  async getAllSequence({ rootState, commit }, { page, size, filter, type, cancelPreviousRequests = true }) {
    try {
      const { data } = await apiClient.post(
        '/api/sequence/get_all',
        {
          page,
          size,
          type,
          project_id: rootState.applicationState.currentProject.id,
          filter
        },
        {
          cancelPreviousRequests
        }
      )

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data
    } catch (error) {
      throw error.message
    }
  },

  async getAllPublicSequences(_, { page, size, package_id }) {
    try {
      const { data } = await apiClient.get('/api/sequence/public/get_all', {
        params: {
          page,
          size,
          package_id
        }
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data
    } catch (error) {
      throw error.message
    }
  },

  async getPurchasedSequences({ rootState, commit }, _) {
    try {
      const { data } = await apiClient.get('/api/sequence/public/purchased', {
        params: {
          project_id: rootState.applicationState.currentProject.id
        }
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('SET_PURCHASED', data)
    } catch (error) {
      throw error.message
    }
  },

  async postPurchasedSequences({ rootState, commit, state }, { sequence_ids, package_ids }) {
    try {
      const { data } = await apiClient.post('/api/sequence/public/purchased', {
        project_id: rootState.applicationState.currentProject.id,
        sequence_ids,
        package_ids
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      const updatedPurchased = {
        package_ids: [...state.purchased.package_ids, ...package_ids],
        sequence_ids: [...state.purchased.sequence_ids, ...sequence_ids]
      }

      commit('SET_PURCHASED', updatedPurchased)
    } catch (error) {
      throw error.message
    }
  },

  setSequence({ commit }, { sequence }) {
    commit('SET_SEQUENCE', sequence)
  },

  async getSequence({ commit }, { sequence_id }) {
    try {
      const { data } = await apiClient.post('/api/sequence/get', {
        sequence_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('SET_SEQUENCE', data)
    } catch (error) {
      throw error.message
    }
  },

  async getCompletedSequence({ commit }, { sequence_id, associate_id }) {
    try {
      const { data } = await apiClient.post('/api/sequence/completed/get', {
        sequence_id,
        associate_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      if (data.sequence) commit('SET_COMPLETED_SEQUENCE', data.sequence)
      else commit('SET_COMPLETED_SEQUENCE', undefined)
    } catch (error) {
      throw error.message
    }
  },

  async getSequenceById({ commit }, { signed_sequence_id, associate_id }) {
    try {
      const { data } = await apiClient.post('/api/sequence/completed/get_by_id', { associate_id, signed_sequence_id })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      if (data.sequence) commit('SET_COMPLETED_SEQUENCE', data.sequence)
      else commit('SET_COMPLETED_SEQUENCE', undefined)
    } catch (error) {
      throw error.message
    }
  },

  async getAllCompletedSequence({ commit }, { sequence_type, associate_id }) {
    try {
      const { data } = await apiClient.post('/api/sequence/completed/associate/get', {
        sequence_type,
        associate_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('SET_COMPLETED_ASSOCIATE_SEQUENCE', {
        payload: data.sequence,
        type: sequence_type
      })
    } catch (error) {
      throw error.message
    }
  },

  async postApproveSequence(
    { rootState },
    { sequence, project_sequence_id, signature_id, associate_id, signed_sequence_id }
  ) {
    try {
      const { data } = await apiClient.post('/api/sequence/completed/approve', {
        sequence,
        project_sequence_id,
        signature_id,
        associate_id,
        project_id: rootState.applicationState.currentProject.id,
        signed_sequence_id,
        reviewer: {
          id: rootState.applicationState.associate.id
        }
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }
    } catch (error) {
      throw error.message
    }
  },

  async postDeclineSequence(
    { rootState },
    { sequence, project_sequence_id, signature_id, associate_id, signed_sequence_id }
  ) {
    try {
      const { data } = await apiClient.post('/api/sequence/completed/decline', {
        sequence,
        project_sequence_id,
        signature_id,
        associate_id,
        project_id: rootState.applicationState.currentProject.id,
        signed_sequence_id,
        reviewer: {
          id: rootState.applicationState.associate.id
        }
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }
    } catch (error) {
      throw error.message
    }
  },

  async postSequence({ commit, rootState }, { sequence }) {
    try {
      const { data } = await apiClient.post('/api/sequence/set', {
        update_active_request: null,
        sequence,
        project_id: rootState.applicationState.currentProject.id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('SET_SEQUENCE', data.sequence)

      return data.sequence
    } catch (error) {
      throw error.message
    }
  },

  async postPackages({ commit, state }, { package_name }) {
    try {
      const { data } = await apiClient.post('/api/sequence/packages', {
        package: {
          name: package_name
        }
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      const updatedPackage = [...state.packages, data.package]

      commit('SET_PACKAGES', updatedPackage)

      return data.package
    } catch (error) {
      throw error.message
    }
  },

  async getPackages({ commit }) {
    try {
      const { data } = await apiClient.get('/api/sequence/packages')

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('SET_PACKAGES', data.items)
    } catch (error) {
      throw error.message
    }
  },

  async deleteSequence(_, { sequence_id }) {
    try {
      const { data } = await apiClient.delete(`/api/sequence/${sequence_id}`)

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }
    } catch (error) {
      throw error.message
    }
  },

  async archiveSequence(_, { sequence_id }) {
    try {
      const { data } = await apiClient.delete(`/api/sequence/completed/delete/${sequence_id}`)

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }
    } catch (error) {
      throw error.message
    }
  },

  async getSequenceDocumentation(_, { cancelPreviousRequests = true }) {
    try {
      const { data } = await apiClient.post('/api/sequence/get/docs', {}, { cancelPreviousRequests })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.documents
    } catch (error) {
      throw error.message
    }
  },

  async getCompanyTrainingCompliance({ rootState }) {
    try {
      const projectId = rootState.applicationState.currentProject.id
      const { data } = await apiClient.get(`/api/project/${projectId}/in_service_hours`)

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg ?? 'An error occurred while loading in-service hours.'}`)
      }

      return data
    } catch (error) {
      throw error.message
    }
  },

  async getCompanyTrainingAssociatesWithShortage({ rootState }) {
    try {
      const projectId = rootState.applicationState.currentProject.id
      const { data } = await apiClient.get(`/api/project/${projectId}/in_service_hours/associates_with_shortage`)

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg ?? 'An error occurred while loading CNA training shortages.'}`)
      }

      return data
    } catch (error) {
      throw error.message
    }
  }
}
